// Recipient master-data fields a formula column can compose (keys mirror the backend's
// RECIPIENT_FIELD_KEYS in customColumns/recipientFields.js).
export const RECIPIENT_FIELDS = [
	{ name: 'salutation', label: 'Anrede' },
	{ name: 'firstName', label: 'Vorname' },
	{ name: 'lastName', label: 'Nachname' },
	{ name: 'fullName', label: 'Voller Name' },
	{ name: 'companyRole', label: 'Position' },
	{ name: 'email', label: 'E-Mail' },
	{ name: 'phone', label: 'Telefon' },
	{ name: 'companyName', label: 'Firmenname' },
	{ name: 'street', label: 'Straße' },
	{ name: 'postalCode', label: 'PLZ' },
	{ name: 'city', label: 'Stadt' },
	{ name: 'website', label: 'Website' },
];

export const COLUMN_TYPE_LABELS = { ai: 'KI', formula: 'Zusammengesetzt' };
